'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createInstantSearch;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _InstantSearch = require('./InstantSearch');

var _InstantSearch2 = _interopRequireDefault(_InstantSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _name$version$descrip = {
  name: 'react-instantsearch',
  version: '5.1.0',
  description: '\u26A1 Lightning-fast search for React and React Native apps, by Algolia',
  keywords: ['algolia', 'components', 'fast', 'instantsearch', 'react', 'react-native', 'search'],
  homepage: 'https://community.algolia.com/react-instantsearch',
  license: 'MIT',
  author: {
    name: 'Algolia, Inc.',
    url: 'https://www.algolia.com'
  },
  main: 'index.js',
  module: 'es/index.js',
  repository: {
    type: 'git',
    url: 'https://github.com/algolia/react-instantsearch'
  },
  scripts: {
    build: './scripts/build.sh',
    'build-and-publish': './scripts/build-and-publish.sh',
    'test:size': 'bundlesize'
  },
  dependencies: {
    algoliasearch: '^3.27.1',
    'algoliasearch-helper': '^2.26.0',
    classnames: '^2.2.5',
    lodash: '^4.17.4',
    'prop-types': '^15.5.10'
  },
  devDependencies: {
    'babel-cli': '6.26.0',
    'babel-core': '6.26.0',
    'babel-plugin-external-helpers': '6.22.0',
    'babel-plugin-inline-json-import': '0.2.1',
    'babel-plugin-lodash': '3.3.2',
    'babel-plugin-transform-react-jsx-source': '6.22.0',
    'babel-preset-env': '1.7.0',
    'babel-preset-react': '6.24.1',
    'babel-preset-stage-2': '6.24.1',
    bundlesize: '0.17.0',
    enzyme: '3.3.0',
    'enzyme-adapter-react-16': '1.1.1',
    'enzyme-to-json': '3.3.4',
    jest: '23.0.1',
    react: '16.4.0',
    'react-dom': '16.4.0',
    'react-native': '0.54.2',
    'react-test-renderer': '16.4.0',
    rollup: '0.59.4',
    'rollup-plugin-babel': '3.0.4',
    'rollup-plugin-commonjs': '9.1.3',
    'rollup-plugin-filesize': '1.5.0',
    'rollup-plugin-node-globals': '1.2.1',
    'rollup-plugin-node-resolve': '3.3.0',
    'rollup-plugin-replace': '2.0.0',
    'rollup-plugin-uglify': '4.0.0'
  },
  jest: {
    snapshotSerializers: ['enzyme-to-json/serializer']
  },
  bundlesize: [{
    path: 'dist/umd/Core.min.js',
    maxSize: '8 kB'
  }, {
    path: 'dist/umd/Connectors.min.js',
    maxSize: '38 kB'
  }, {
    path: 'dist/umd/Dom.min.js',
    maxSize: '62 kB'
  }]
},
    version = _name$version$descrip.version;

/**
 * Creates a specialized root InstantSearch component. It accepts
 * an algolia client and a specification of the root Element.
 * @param {function} defaultAlgoliaClient - a function that builds an Algolia client
 * @param {object} root - the defininition of the root of an InstantSearch sub tree.
 * @returns {object} an InstantSearch root
 */

function createInstantSearch(defaultAlgoliaClient, root) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(CreateInstantSearch, _Component);

    function CreateInstantSearch() {
      var _ref;

      _classCallCheck(this, CreateInstantSearch);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = CreateInstantSearch.__proto__ || Object.getPrototypeOf(CreateInstantSearch)).call.apply(_ref, [this].concat(args)));

      if (_this.props.searchClient) {
        if (_this.props.appId || _this.props.apiKey || _this.props.algoliaClient) {
          throw new Error('react-instantsearch:: `searchClient` cannot be used with `appId`, `apiKey` or `algoliaClient`.');
        }
      }

      if (_this.props.algoliaClient) {
        // eslint-disable-next-line no-console
        console.warn('`algoliaClient` option was renamed `searchClient`. Please use this new option before the next major version.');
      }

      _this.client = _this.props.searchClient || _this.props.algoliaClient || defaultAlgoliaClient(_this.props.appId, _this.props.apiKey);

      if (typeof _this.client.addAlgoliaAgent === 'function') {
        _this.client.addAlgoliaAgent('react-instantsearch ' + version);
      }
      return _this;
    }

    _createClass(CreateInstantSearch, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var props = this.props;

        if (nextProps.searchClient) {
          this.client = nextProps.searchClient;
        } else if (nextProps.algoliaClient) {
          this.client = nextProps.algoliaClient;
        } else if (props.appId !== nextProps.appId || props.apiKey !== nextProps.apiKey) {
          this.client = defaultAlgoliaClient(nextProps.appId, nextProps.apiKey);
        }

        if (typeof this.client.addAlgoliaAgent === 'function') {
          this.client.addAlgoliaAgent('react-instantsearch ' + version);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          _InstantSearch2.default,
          {
            createURL: this.props.createURL,
            indexName: this.props.indexName,
            searchState: this.props.searchState,
            onSearchStateChange: this.props.onSearchStateChange,
            onSearchParameters: this.props.onSearchParameters,
            root: this.props.root,
            searchClient: this.client,
            algoliaClient: this.client,
            refresh: this.props.refresh,
            resultsState: this.props.resultsState
          },
          this.props.children
        );
      }
    }]);

    return CreateInstantSearch;
  }(_react.Component), _class.propTypes = {
    algoliaClient: _propTypes2.default.object,
    searchClient: _propTypes2.default.object,
    appId: _propTypes2.default.string,
    apiKey: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    indexName: _propTypes2.default.string.isRequired,
    createURL: _propTypes2.default.func,
    searchState: _propTypes2.default.object,
    refresh: _propTypes2.default.bool.isRequired,
    onSearchStateChange: _propTypes2.default.func,
    onSearchParameters: _propTypes2.default.func,
    resultsState: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
    root: _propTypes2.default.shape({
      Root: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]).isRequired,
      props: _propTypes2.default.object
    })
  }, _class.defaultProps = {
    refresh: false,
    root: root
  }, _temp;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/core/createInstantSearch.js
// module id = 1067
// module chunks = 142807904292071